// extracted by mini-css-extract-plugin
export default {"cardTitle":"_3sE1grFkIDpJgdTZ8WIksN","cardAction":"_32DnSqobaDcHEwxJHifvzQ","splashContainer":"_3RGbsBsF8x_bnW1_z6j_tc","sectionContent":"YJ89KrSVzMd3W67AiMXzU"};